import Chip from '@mui/material/Chip';
import {
  FilterChipsContainer,
  ClearAllFiltersButton,
  LoadingSpinner,
  filterChipSx,
} from 'components/filters/FilterElements';

export interface FilterChipDef {
  key: string;
  label: string;
  onDelete: () => void;
}

interface FilterChipRowProps {
  chips: FilterChipDef[];
  onClearAll: () => void;
  clearAllLabel: string;
  isLoading?: boolean;
}

export const FilterChipRow = ({ chips, onClearAll, clearAllLabel, isLoading = false }: FilterChipRowProps) => {
  if (chips.length === 0) {
    return null;
  }

  return (
    <FilterChipsContainer>
      {chips.map(({ key, label, onDelete }) => (
        <Chip key={key} label={label} size="small" variant="outlined" onDelete={onDelete} sx={filterChipSx} />
      ))}
      <ClearAllFiltersButton onClick={onClearAll}>{clearAllLabel}</ClearAllFiltersButton>
      {isLoading && <LoadingSpinner />}
    </FilterChipsContainer>
  );
};
